export const TIMELINE_START_MINUTES = 9 * 60;
export const TIMELINE_END_MINUTES = 19 * 60;
export const STEP_MINUTES = 5;
export const MIN_SLOT_MINUTES = 15;
export const DEFAULT_SLOT_MINUTES = 60;
export const FOCUS_SLOT_PAST_GRACE_MINUTES = 5;

export const timelineDuration = TIMELINE_END_MINUTES - TIMELINE_START_MINUTES;

export const FOCUS_TIME_LIMIT_ERROR_TEXT = "Your focus time can't be more than";
export const FOCUS_SCHEDULES_RESOURCE_URL = '/focus-schedules';
